module.exports = __webpack_public_path__ + "img/img114.3fa2d2b4.svg";